import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.incident-vorlagen-liste';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentVorlagenListeEffects {

    IncidentVorlagenListe$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_INCIDENT_VORLAGEN_LISTE),
        mergeMap((x: ac.GetIncidentVorlagenListeAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getIncidentVorlagenListe().pipe(
                map((result: any) => {
                    return new ac.GetIncidentVorlagenListeErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetIncidentVorlagenListeFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
